import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '../notification.service';
import { PatientService } from '../shared/patient.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  feedbackForm: FormGroup;
  constructor(public router : Router, public service : PatientService,
    private notificationService: NotificationService, private formBuilder: FormBuilder
    ) { }

  ngOnInit(): void {
    this.resetForm()
  
  }
resetForm(){
  this.feedbackForm = new FormGroup({
    name: new FormControl('',Validators.required),
    mobile: new FormControl('',Validators.required),
    email: new FormControl('',Validators.required),
    message: new FormControl('',Validators.required),
  });
}
  onSubmit(){
    this.service.feedback = this.feedbackForm.value
      this.service.userfeedback().subscribe(Response => {
        if (Response != 0) {
          this.notificationService.success(':: Thanks for you feedback');
          window.open('http://www.minhajlab.com.pk/')
        }
        else {
          this.notificationService.warn(':: Unable to connect server!');
          this.resetForm();
        }
      })
  }

  cancel(){
    window.open('http://www.minhajlab.com.pk/');
  }
}
